import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// core styles
import "./template/scss/volt.scss";

// vendor styles
import "@fortawesome/fontawesome-free/css/all.css";
import "react-datetime/css/react-datetime.css";

import ScrollToTop from "./template/components/ScrollToTop";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
	<>
		<BrowserRouter>
			<ScrollToTop />
			<App />
		</BrowserRouter>
	</>,
	document.getElementById("root")
);
